import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoddleState } from '@doddly/core';

@Component({
  selector: 'ly-post-status-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './post-status-indicator.component.html',
  styleUrl: './post-status-indicator.component.scss',
})
export class PostStatusIndicatorComponent {
  @Input({})
  status: DoddleState | undefined = 'draft';
}
